<template>
  <div class="vm-action-sheet" :class="[browser_size, classname, is_show, is_show ? 'on' : '']" :style="style" @click.self="close">
    <component :is="component" :params="params" :class="{'safe-space': is_safe_space}"></component>
  </div>
  <!-- v-click-outside="close" -->
</template>

<script>
import { mapState } from "vuex";
import ActionFeedSetting from "@/components/ActionSheet/ActionFeedSetting";
import ActionFeedFilter from "@/components/ActionSheet/ActionFeedFilter";
import ActionLang from "@/components/ActionSheet/ActionLang";
import ActionQrCode from "@/components/ActionSheet/ActionQrCode";
// import ActionSheetAvatar from "@/components/ActionSheetAvatar";
export default {
  name: "action-sheet",
  props: {
  },
  components:{
    ActionFeedSetting,
    ActionFeedFilter,
    ActionLang,
    ActionQrCode,
    // ActionSheetAvatar,
  },
  data() {
    return {
      is_show:false,
      component:'',
      params:null,
      target: null,
      location_type:['right','bottom'],
      style:{},
      rect:{},
      is_safe_space:false,
      classname:'',
    };
  },
  watch:{
      target(v){
        if(v){
            this.set_location()
        }
      },
      browser_size(){
         this.close()
      },
      $route(v){
        if(this.GL.ENV.is_afd_client && this.GL.ENV.is_ios && [
          'dashboardMark-post',
          'feed',
          'dashboardStats',
          'dashboardSponsored-bill',
          'dashboardIncome',
          'dashboardSponsoring',
          'dashboardSponsors',
          'dashboardMark',
          'dashboardOrder',
        ].indexOf(v.name) != -1){
          this.is_safe_space = true
        }else{
          this.is_safe_space = false
        }
        this.close()
      }
  },
  computed: {
    ...mapState('app', [
      'browser_size',
    ]),
  },
  mounted() {

  },
  methods: {
    open(config){
        if(this.is_show){ //防止重复打开
            this.close()
            this.$nextTick(() => {
                this.open(config)
            })
            return false
        }
        this.component = config.component
        if(config.location_type){
          this.location_type = config.location_type
        }
        if(config.params){
          this.params = config.params
        }
        if(config.classname){
          this.classname = config.classname
        }
        this.is_show = true;
        this.target = config.target
    },
    close(){
        this.component = ''
        this.is_show = false;
        this.style = {}
        this.target = null
        this.classname = '';
        this.location_type = ['right','bottom'];
    },
    set_location(){
        if(!this.target){
            return
        }
        // console.log(this.target)
        this.rect = this.target.getBoundingClientRect()
        let x = this.target.offsetLeft;
        let y = this.target.offsetTop;
        let w = this.target.offsetWidth;
        let h = this.target.offsetHeight;
        let W = document.body.clientWidth;
        let H = document.body.clientHeight;

        let left = this.rect.left;
        let top = this.rect.top;

        if(this.location_type.indexOf('right') != -1){
            this.style.right = this.browser_size == 'small' ? false : `${W - x - w}px`
        }
        if(this.location_type.indexOf('bottom') != -1){
            this.style.top = this.browser_size == 'small' ? false : `${y + h}px`
        }
        if(this.location_type.indexOf('left') != -1){
            this.style.left = this.browser_size == 'small' ? false : `${x}px`
        }
        if(this.location_type.indexOf('right2') != -1){
            this.style.right = this.browser_size == 'small' ? false : `${W - left - w}px`
        }
        if(this.location_type.indexOf('bottom2') != -1){
            this.style.top = this.browser_size == 'small' ? false : `${top + h}px`
        }
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-action-sheet{
    position:absolute;
    z-index:-1;
    box-shadow: $layer-shadow;
    opacity:0;
    &.on{
      z-index: 20;
      opacity:1;
    }

    &.qr-code,
    &.lang{
      z-index:111;
      position:fixed;
      left:0;
      height:100vh;
      width:100%;
      top:0;
      background:$black-3;
      display:flex;
      justify-content: center;
      align-items: center;
    }
    &.small{
      height:100vh;
      width:100%;
      background: $black-3;
      position:fixed;
      left:0;
      top:0;
      box-shadow:none;
    //   .list-box{
    //     background: $white;
    //     border-radius:8px 8px 0 0;
    //     position:absolute;
    //     left:0;
    //     width:100%;
    //     bottom:0;
    //   }
    }
}
</style>
